/* eslint-disable no-unused-vars */
import { useCallback, useState } from 'react';
import { ModalBase, ModalHeader } from 'components';
import * as S from './ChooseAudience.styled';
import ChangingTabs from './changingTabsHeader/ChangingTabs';
import ExistingAudience from './existingAudience/ExistingAudience';
import AddNewAudience from './addNewAudience/AddNewAudience';

const ChooseAudienceModal = ({ handleCloseWindow }) => {
  const [currentTab, setCurrentTab] = useState('existing_audience');
  const handleChange = useCallback((e, newValue) => {
    setCurrentTab(newValue);
  }, []);
  return (
    <ModalBase>
      <S.Box>
        <ModalHeader title='Manage Audience' close={handleCloseWindow} />
        <ChangingTabs
          handleChange={handleChange}
          currentTab={currentTab}
          existing_audience={<ExistingAudience handleCloseWindow={handleCloseWindow} />}
          add_new_audience={
            <AddNewAudience handleCloseWindow={handleCloseWindow} handleChangeTab={setCurrentTab} />
          }
        />
      </S.Box>
    </ModalBase>
  );
};

export default ChooseAudienceModal;
